/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.PaymentBean = factory(root.BelfastpilatesProductionappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PaymentBean model module.
   * @module model/PaymentBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PaymentBean</code>.
   * @alias module:model/PaymentBean
   * @class
   */
  var exports = function() {
    var _this = this;


































  };

  /**
   * Constructs a <code>PaymentBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PaymentBean} obj Optional instance to populate.
   * @return {module:model/PaymentBean} The populated <code>PaymentBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('applicationFee')) {
        obj['applicationFee'] = ApiClient.convertToType(data['applicationFee'], 'Boolean');
      }
      if (data.hasOwnProperty('applicationFeeAmount')) {
        obj['applicationFeeAmount'] = ApiClient.convertToType(data['applicationFeeAmount'], 'String');
      }
      if (data.hasOwnProperty('chargeId')) {
        obj['chargeId'] = ApiClient.convertToType(data['chargeId'], 'String');
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('countryCode')) {
        obj['countryCode'] = ApiClient.convertToType(data['countryCode'], 'String');
      }
      if (data.hasOwnProperty('currencyCode')) {
        obj['currencyCode'] = ApiClient.convertToType(data['currencyCode'], 'String');
      }
      if (data.hasOwnProperty('currencyDecimalPlaces')) {
        obj['currencyDecimalPlaces'] = ApiClient.convertToType(data['currencyDecimalPlaces'], 'String');
      }
      if (data.hasOwnProperty('currencySymbol')) {
        obj['currencySymbol'] = ApiClient.convertToType(data['currencySymbol'], 'String');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('dateDeleted')) {
        obj['dateDeleted'] = ApiClient.convertToType(data['dateDeleted'], 'Date');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('idempotencyKey')) {
        obj['idempotencyKey'] = ApiClient.convertToType(data['idempotencyKey'], 'String');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime2')) {
        obj['lastUpdatedDateTime2'] = ApiClient.convertToType(data['lastUpdatedDateTime2'], 'Date');
      }
      if (data.hasOwnProperty('nextAction')) {
        obj['nextAction'] = ApiClient.convertToType(data['nextAction'], 'String');
      }
      if (data.hasOwnProperty('nextActionReturnUrl')) {
        obj['nextActionReturnUrl'] = ApiClient.convertToType(data['nextActionReturnUrl'], 'String');
      }
      if (data.hasOwnProperty('nextActionUrl')) {
        obj['nextActionUrl'] = ApiClient.convertToType(data['nextActionUrl'], 'String');
      }
      if (data.hasOwnProperty('paymentIntentId')) {
        obj['paymentIntentId'] = ApiClient.convertToType(data['paymentIntentId'], 'String');
      }
      if (data.hasOwnProperty('reference')) {
        obj['reference'] = ApiClient.convertToType(data['reference'], 'String');
      }
      if (data.hasOwnProperty('searchId1')) {
        obj['searchId1'] = ApiClient.convertToType(data['searchId1'], 'String');
      }
      if (data.hasOwnProperty('searchId2')) {
        obj['searchId2'] = ApiClient.convertToType(data['searchId2'], 'String');
      }
      if (data.hasOwnProperty('searchId3')) {
        obj['searchId3'] = ApiClient.convertToType(data['searchId3'], 'String');
      }
      if (data.hasOwnProperty('searchId4')) {
        obj['searchId4'] = ApiClient.convertToType(data['searchId4'], 'String');
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('stripeAuthCode')) {
        obj['stripeAuthCode'] = ApiClient.convertToType(data['stripeAuthCode'], 'String');
      }
      if (data.hasOwnProperty('stripeGrantType')) {
        obj['stripeGrantType'] = ApiClient.convertToType(data['stripeGrantType'], 'String');
      }
      if (data.hasOwnProperty('stripePublishKey')) {
        obj['stripePublishKey'] = ApiClient.convertToType(data['stripePublishKey'], 'String');
      }
      if (data.hasOwnProperty('system')) {
        obj['system'] = ApiClient.convertToType(data['system'], 'String');
      }
      if (data.hasOwnProperty('token')) {
        obj['token'] = ApiClient.convertToType(data['token'], 'String');
      }
      if (data.hasOwnProperty('total')) {
        obj['total'] = ApiClient.convertToType(data['total'], 'String');
      }
      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('voucherId')) {
        obj['voucherId'] = ApiClient.convertToType(data['voucherId'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} applicationFee
   */
  exports.prototype['applicationFee'] = undefined;
  /**
   * @member {String} applicationFeeAmount
   */
  exports.prototype['applicationFeeAmount'] = undefined;
  /**
   * @member {String} chargeId
   */
  exports.prototype['chargeId'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {String} countryCode
   */
  exports.prototype['countryCode'] = undefined;
  /**
   * @member {String} currencyCode
   */
  exports.prototype['currencyCode'] = undefined;
  /**
   * @member {String} currencyDecimalPlaces
   */
  exports.prototype['currencyDecimalPlaces'] = undefined;
  /**
   * @member {String} currencySymbol
   */
  exports.prototype['currencySymbol'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {Date} dateDeleted
   */
  exports.prototype['dateDeleted'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {String} idempotencyKey
   */
  exports.prototype['idempotencyKey'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime2
   */
  exports.prototype['lastUpdatedDateTime2'] = undefined;
  /**
   * @member {String} nextAction
   */
  exports.prototype['nextAction'] = undefined;
  /**
   * @member {String} nextActionReturnUrl
   */
  exports.prototype['nextActionReturnUrl'] = undefined;
  /**
   * @member {String} nextActionUrl
   */
  exports.prototype['nextActionUrl'] = undefined;
  /**
   * @member {String} paymentIntentId
   */
  exports.prototype['paymentIntentId'] = undefined;
  /**
   * @member {String} reference
   */
  exports.prototype['reference'] = undefined;
  /**
   * @member {String} searchId1
   */
  exports.prototype['searchId1'] = undefined;
  /**
   * @member {String} searchId2
   */
  exports.prototype['searchId2'] = undefined;
  /**
   * @member {String} searchId3
   */
  exports.prototype['searchId3'] = undefined;
  /**
   * @member {String} searchId4
   */
  exports.prototype['searchId4'] = undefined;
  /**
   * @member {String} status
   */
  exports.prototype['status'] = undefined;
  /**
   * @member {String} stripeAuthCode
   */
  exports.prototype['stripeAuthCode'] = undefined;
  /**
   * @member {String} stripeGrantType
   */
  exports.prototype['stripeGrantType'] = undefined;
  /**
   * @member {String} stripePublishKey
   */
  exports.prototype['stripePublishKey'] = undefined;
  /**
   * @member {String} system
   */
  exports.prototype['system'] = undefined;
  /**
   * @member {String} token
   */
  exports.prototype['token'] = undefined;
  /**
   * @member {String} total
   */
  exports.prototype['total'] = undefined;
  /**
   * @member {String} type
   */
  exports.prototype['type'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {String} voucherId
   */
  exports.prototype['voucherId'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/PaymentBean.js